import http from "../common/http-common";

export async function getDashboardDetails() {
  return http.get("/api/v1/dashboard",{
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
}